module.exports = __webpack_public_path__ + "img/reports-categories.df1b0b55.jpg";